import { render, staticRenderFns } from "./list_price.vue?vue&type=template&id=cba998c6&scoped=true&"
import script from "./list_price.vue?vue&type=script&lang=js&"
export * from "./list_price.vue?vue&type=script&lang=js&"
import style0 from "./list_price.vue?vue&type=style&index=0&id=cba998c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba998c6",
  null
  
)

export default component.exports